import { render, staticRenderFns } from "./TagListing.vue?vue&type=template&id=3959a9ae&"
import script from "./TagListing.vue?vue&type=script&lang=js&"
export * from "./TagListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports